<template>
  <a-card class="c_annualPlafon">
    <div slot="title" class="m-display-flex space-between custom">
      <span class="cmain-title"><a-icon type="project" />&nbsp;Cash Management - Annual Plafon</span>
      <a-button v-if="isVPF||isKeu" type="primary" class="cbtn-create" icon ="plus" 
        @click="showCreateDialog()"
        :loading="loading.show_load"
        :disabled="loading.page"
      >Create</a-button>
      <!-- :disabled="loading.page" -->
    </div>
    <a-card>
      <div class="m-display-flex space-between align-middle">
        <div :class="getScreen?'m-width-full':'m-display-flex'">
          <div :style="getScreen?'width:100%;':''" :class="getScreen?'margin-top':''">
            &nbsp;Type :&nbsp;
            <a-select
              placeholder="Choose"
              v-model="selected.type"
              @change="changeType"
              :filterOption="filterOption"
              showSearch
              :style="getScreen?'':'width:180px'"
              :class="getScreen?'m-width-full':''"
              :disabled="loading.page"
            >
              <a-select-option v-for="item in typeList" :key="item.value" :value="item.value">{{ item.label }}</a-select-option>
            </a-select>
          </div>
          <div :style="getScreen?'width:100%':''">
            &nbsp;Year :&nbsp;<a-select
              placeholder="Choose"
              v-model="selected.year"
              @change="changeYear"
              :filterOption="filterOption"
              showSearch
              :style="getScreen?'':'width:70px'"
              :class="getScreen?'m-width-full':''"
              :disabled="loading.page"
            >
              <a-select-option v-for="item in yearComputed" :key="item.year" :value="item.year">{{ item.year }}</a-select-option>
            </a-select>
          </div>
          <div :style="getScreen?'width:100%;':''" :class="getScreen?'margin-top':''">
            &nbsp;Version :&nbsp;<a-select
              placeholder="Choose"
              v-model="selected.version"
              @change="changeVersion"
              :filterOption="filterOption"
              showSearch
              :style="getScreen?'':'width:130px'"
              :class="getScreen?'m-width-full':''"
              :disabled="loading.page"
            >
              <a-select-option v-for="item in version" :key="item.version" :value="item.version">{{ item.version }} | {{ item.active_sts=="1"?"Active":"Non Active" }}</a-select-option>
            </a-select>
          </div>
        </div>
        <a-button v-if="!getScreen" type="secondary" icon="reload" @click="fetch()">Refresh</a-button>
      </div>
    </a-card>
    <a-row :gutter="8">
      <a-col :xs="{ span: 24 }" :lg="{ span: 11 }">
        <a-collapse v-model="activeKey.header" :activeKey="activeKey.header"
        :class="getScreen?'margin-top':''"
        >
          <a-collapse-panel key="1">
            <span slot="header">
              <div class="m-display-flex space-between align-middle">
                <div v-if="!getScreen">
                  Type : {{ data_header.type_label ? data_header.type_label : "-" }}
                  &nbsp;&nbsp;&nbsp;Year : {{ selected.year ? selected.year : "-" }}
                  &nbsp;&nbsp;&nbsp;Version : {{ selected.version ? selected.version : "-" }}
                </div>
                <div v-else>
                  {{ data_header.type_label ? data_header.type_label : "-" }} : 
                  {{ selected.year ? selected.year : "-" }} : 
                  {{ selected.version ? selected.version : "-" }}
                </div>
              </div>
            </span>
            <div class="m-display-flex space-between margin-bottom" >
              <div><b>Status : </b><Status :status="getLblSts(data_header.status?data_header.status.replace('non active', 'NON ACTIVE'):data_header.status)"/></div>
              <div>
                <a-button type="danger" class="margin-right" icon="edit" size="small" 
                  v-if="isVPF || isKeu"
                  @click="(e)=>{showEditDialog(e)}"
                  :disabled="loading.page || !selected.year || !(data_header.status=='active')"
                  > 
                  {{!getScreen ? 'Edit' : ''}}
                </a-button>
                <a-button type="primary" icon="file" size="small" 
                  @click="gotoManifest(data_header.id)"
                  :disabled="loading.page || !selected.year || !data_header.status">
                  {{!getScreen ? 'Manifest' : ''}}
                </a-button>
              </div>
            </div>
            <a-table 
              :rowKey="(record, index) => {return index;}"
              :showHeader="false"
              :columns="columns" 
              :data-source="dtl"
              :loading="loading.page"
              :pagination="false"
              :class="'hdr_plfn'"
              :rowClassName="(record, index) => {return record.plafon_value-record.allocated_value<0 ? 'option_plfn ngabango' : ' option_plfn';}"
              bordered>
              <template slot="title" slot-scope="currentPageData">
                <!-- <div class="m-display-flex space-between align-middle row_h">
                  <a-tooltip placement="bottomLeft">
                    <b :class="getScreen?'m-width-full':''">Total Est Contract Value&nbsp;<sup><a-icon type="info-circle"/></sup></b>
                    <template slot="title">
                      <span>Total Est Contract Value is the total number of estimated contact values ​​in the pipeline</span>
                    </template>
                  </a-tooltip>
                  <span :class="getScreen?'m-width-full':''">{{ formatCurrency('IDR', data_header.est_contract_value?data_header.est_contract_value:0) }}</span>
                </div> -->
                <!-- <div class="m-display-flex space-between align-middle row_h"> -->
                  <!-- <a-input-number
                    v-model="data_header.cashflow_value"
                    class="m-width-full"
                    style="display: flex;max-width: 50%;text-align:right"
                    :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                    :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
                    disabled
                  ></a-input-number> -->
                  <!-- <span :class="getScreen?'m-width-full':''">{{ formatCurrency('IDR', data_header.cashflow_value?data_header.cashflow_value:0) }}</span>
                </div> -->
                <div class="m-display-flex space-between align-middle row_h">
                  <a-tooltip placement="bottomLeft">
                    <b :class="getScreen?'m-width-full':''">Total Plafon&nbsp;<sup><a-icon type="info-circle"/></sup></b>
                    <template slot="title">
                      <span>Total Plafon is taken from the ceiling amount of the entire directorate</span>
                    </template>
                  </a-tooltip>
                  <span :class="getScreen?'m-width-full':''">{{ formatCurrency('IDR', data_header.total_plafon?data_header.total_plafon:0) }}</span>
                </div>
                <div class="m-display-flex space-between align-middle row_h">
                  <a-tooltip placement="bottomLeft">
                    <b :class="getScreen?'m-width-full':''">Total Allocated&nbsp;<sup><a-icon type="info-circle"/></sup></b>
                    <template slot="title">
                        <span>Total Allocated is taken from the total amount of the budget value of all directorates</span>
                      </template>
                    </a-tooltip>
                  <span :class="getScreen?'m-width-full':''">{{ formatCurrency('IDR', data_header.total_allocated?data_header.total_allocated:0) }}</span>
                </div>
                <div class="m-display-flex space-between align-middle row_h">
                  <a-tooltip placement="bottomLeft">
                    <b :class="getScreen?'m-width-full':''">Unallocated Plafon&nbsp;<sup><a-icon type="info-circle"/></sup></b>
                    <template slot="title">
                      <span>Unallocated Plafon is taken from the total ceiling minus of the Total Allocated</span>
                    </template>
                  </a-tooltip>
                  <span :class="getScreen?'m-width-full':''">{{ formatCurrency('IDR', (data_header.total_plafon?data_header.total_plafon:0)-(data_header.total_allocated?data_header.total_allocated:0)) }}</span>
                </div>
                <div class="m-display-flex space-between align-middle row_h">
                  <a-tooltip placement="bottomLeft">
                    <b :class="getScreen?'m-width-full':''">Total Realization&nbsp;<sup><a-icon type="info-circle"/></sup></b>
                    <template slot="title">
                      <span>Total Realization is overall budget realization value in all directorates</span>
                    </template>
                  </a-tooltip>
                  <span :class="getScreen?'m-width-full':''">{{ formatCurrency('IDR', data_header.realization_value?data_header.realization_value:0) }}</span>
                </div>
                <br/>
                <div class="m-display-flex space-between align-middle row_h">
                  <b>Plafon Value Directorate :</b>
                </div>
              </template>
              <template slot="hdr" slot-scope="text, item, index">
                <div class="hdr_plfn_selection" @click="(e)=>{showdtlData(e,item.id_dtl)}" :tabindex="index">
                  <a-row>
                    <a-col :xs="{ span: 2 }" :sm="{ span: 1 }" :lg="{ span: 2 }" style="text-align: right;padding-right:5px"><b>{{ index+1 }}.</b></a-col>
                    <a-col :xs="{ span: 22 }" :sm="{ span: 23 }" :lg="{ span: 22 }"><b>{{ item.directorat }}</b></a-col>
                  </a-row>
                  <a-row>
                    <a-col :xs="{ span: 24 }" :lg="{ span: 2 }"></a-col>
                    <a-col :xs="{ span: 24 }" :lg="{ span: 7 }">Plafon<span v-if="getScreen"> :</span></a-col>
                    <a-col :xs="{ span: 24 }" :lg="{ span: 15 }" style="text-align: right">{{ formatCurrency('IDR', item.plafon_value) }}</a-col>
                  </a-row>
                  <a-row>
                    <a-col :xs="{ span: 24 }" :lg="{ span: 2 }"></a-col>
                    <a-col :xs="{ span: 24 }" :lg="{ span: 7 }">Budgeted<span v-if="getScreen"> :</span></a-col>
                    <a-col :xs="{ span: 24 }" :lg="{ span: 15 }" style="text-align: right">{{ formatCurrency('IDR', item.allocated_value) }}</a-col>
                  </a-row>
                  <a-row>
                    <a-col :xs="{ span: 24 }" :lg="{ span: 2 }"></a-col>
                    <a-col :xs="{ span: 24 }" :lg="{ span: 7 }">Realized<span v-if="getScreen"> :</span></a-col>
                    <a-col :xs="{ span: 24 }" :lg="{ span: 15 }" style="text-align: right">{{ formatCurrency('IDR', item.realization_value) }}</a-col>
                  </a-row>
                </div>
              </template>
            </a-table>
          </a-collapse-panel>
        </a-collapse>
      </a-col>
      <a-col :xs="{ span: 24 }" :lg="{ span: 13 }">
        <Details :loading="data_detail.loading" :datasource="data_detail.data"  :versionType="data_header.type" type="annual"/>
      </a-col>
    </a-row>

    <a-modal
      v-if="modal_create.visible"
      v-model="modal_create.visible"
      :title="(modal_create.mode=='create' ? 'Create' : 'Edit' ) + ' Cash Management Annual Plafon'"
      :width="getScreen ? '95%' : '700px'"
      class="cAnnualfromcreate"
      :confirmLoading="loading.saveCreate"
      @ok="handleOkCreate"
      centered
      cancelText="Cancel"
      okText="Submit"
      :closeable="false"
    >
    <a-spin
      tip="Please Wait, its still loading data realization!"
      :spinning="loading.getrealization"
    >
      <a-form-model ref="entriForm" :model="modal_create.form" :rules="modal_create.rules">
        <a-row :gutter="8">
          <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
            <a-form-model-item label="Year" prop="year">
              <a-select showSearch v-model="modal_create.form.year" @change="changeYearCreate"
              :disabled="modal_create.mode=='edit'"
              >
                <a-select-option v-for="item in modal_create.optionyear" :key="item.year">{{ item.year }}</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
            <a-form-model-item label="Type Annual" prop="typeAnnual">
              <a-select showSearch v-model="modal_create.form.typeAnnual" @change="changeTypeAnnual"
              :disabled="modal_create.mode=='edit'"
              >
                <a-select-option v-for="item in typeList" :key="item.value" :value="item.value">{{ item.label }}</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <!-- <a-col :xs="{ span: 24 }" :lg="{ span: modal_create.form.typeAnnual=='X_ABAIKAN_X'?8:12 }">
            <a-form-model-item label="Total Est. Contract Value" prop="total_est_contract_value">
              <a-input-number :min="0" class="m-width-full"
                v-model="modal_create.form.total_est_contract_value" 
                @keydown="onlyNumber"
                disabled
                :formatter="value => value ? `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ','): value"
                :parser="(value) => (value ? value.replace(/\\s?|(,*)/g, ''): value).toString()">
              </a-input-number>
            </a-form-model-item>
          </a-col> -->
          <a-col :xs="{ span: 24 }" :lg="{ span: 8 }" v-if="modal_create.form.typeAnnual && modal_create.form.typeAnnual=='X_ABAIKAN_X'">
            <a-form-model-item label="Est. Pipeline Plafon" prop="est_pipeline_plafon">
              <a-input-number :min="0" class="m-width-full"
                v-model="modal_create.form.estimatePipelinePlafon" 
                @keydown="onlyNumber"
                @change="validateECV"
                :disabled="modal_create.mode=='edit'"
                :formatter="value => value ? `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ','): value"
                :parser="(value) => (value ? value.replace(/\\s?|(,*)/g, ''): value).toString()">
              </a-input-number>
            </a-form-model-item>
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 8 }" v-if="modal_create.form.typeAnnual && modal_create.form.typeAnnual=='X_ABAIKAN_X'">
            <a-form-model-item label="Est. Directorate Cost" prop="est_directorate_cost">
              <a-input-number :min="0" class="m-width-full"
                v-model="modal_create.form.estimateDirectorateCost"
                :disabled="modal_create.mode=='edit'"
                @keydown="onlyNumber"
                @change="validateECV"
                :formatter="value => value ? `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ','): value"
                :parser="(value) => (value ? value.replace(/\\s?|(,*)/g, ''): value).toString()">
              </a-input-number>
            </a-form-model-item>
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
            <a-form-model-item label="Total Plafon" prop="actual_value_cashflow">
              <a-input-number 
                v-if="modal_create.form.typeAnnual=='X_ABAIKAN_X'"
                :min="0" class="m-width-full"
                v-model="modal_create.form.actual_value_cashflow"
                :disabled="true"
                @keydown="onlyNumber"
                @change="validateECV"
                :formatter="value => value ? `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ','): value"
                :parser="(value) => (value ? value.replace(/\\s?|(,*)/g, ''): value).toString()">
              </a-input-number>
              <a-input-number 
                v-else
                :min="0" class="m-width-full"
                v-model="modal_create.totalPlafon"
                :disabled="true"
                @keydown="onlyNumber"
                :formatter="value => value ? `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ','): value"
                :parser="(value) => (value ? value.replace(/\\s?|(,*)/g, ''): value).toString()">
              </a-input-number>
            </a-form-model-item>
          </a-col>
        </a-row>
        <!-- <div v-if="modal_create.form.typeAnnual && modal_create.isoverlimitPlafon">
          <small style="color:red"> 
            {{
            '* Total Est. Plafon is over limit from Est. Cashflow Value!'
            }}
          </small>
        </div> -->
        <a-table 
          :rowKey="(record, index) => { return index; }"
          :columns="columnForm"
          :dataSource="modal_create.tableForm"
          size="small" bordered :pagination="false"
          class="margin-top plafonformtables"
          :rowClassName="(record, index) => {
            return record.dtl.isoverlimit ? 'overvalueRow' : ( record.direktorat.toLowerCase()=='total' ? 'cSUMMARY' :'');}"
        >
          <template slot="pipelineHeaderTitle">
            <div>Pipeline Plafon</div>
            <small style="color:red" v-if="modal_create.form.typeAnnual && modal_create.isoverlimitPipeline">
              Total Pipeline Plafon is not match with Estimated Pipeline Plafon
            </small>
          </template>
          <template slot="directorateCostHeaderTitle">
            <div>Directorate Cost</div>
            <small style="color:red" v-if="modal_create.form.typeAnnual && modal_create.isoverlimitDirectorateCost">
              Total Directorate Cost is not match with Estimated Directorate Cost
            </small>
          </template>
          <template slot="plafonHeaderTitle">
            <div>Plafon</div>
            <small style="color:red" v-if="modal_create.form.typeAnnual && modal_create.isoverlimitPlafon">
              Total Est. Plafon is not match with Total Est. Contract Value
            </small>
          </template>
          <template slot="directorate" slot-scope="item">
            <b>{{ item.direktorat }}</b>
            <div class="m-display-flex space-between custom" >
              <small v-if="item.direktorat.toLowerCase()!='total'">Total Realized : </small>
              <small v-if="item.direktorat.toLowerCase()=='finance'">{{formatCurrency('IDR', modal_create.form.realized_finance)}}</small>
              <small v-if="item.direktorat.toLowerCase()=='corporate'">{{formatCurrency('IDR', modal_create.form.realized_corporate)}}</small>
              <small v-if="item.direktorat.toLowerCase()=='marketing'">{{formatCurrency('IDR', modal_create.form.realized_marketing)}}</small>
              <small v-if="item.direktorat.toLowerCase()=='operation'">{{formatCurrency('IDR', modal_create.form.realized_operation)}}</small>
              <small v-if="item.direktorat.toLowerCase()=='technology'">{{formatCurrency('IDR', modal_create.form.realized_technology)}}</small>
              <small v-if="item.direktorat.toLowerCase()=='international business development'">{{formatCurrency('IDR', modal_create.form.realized_ibd)}}</small>
            </div>
          </template>
          <template slot="pipelinePlafon" slot-scope="text, item, index">
            <div v-if="modal_create.form.typeAnnual && modal_create.form.typeAnnual=='X_ABAIKAN_X' &&
              item.direktorat.toLowerCase()=='total'">
              <div class="m-text-align-center" >
                  <small> {{"TOTAL PIPELINE PLAFON :" }} </small>
              </div>
            </div>
            <a-form-model-item v-else :prop="'pipelinePlafon_'+index+'_'+item.direktorat" type="number" required>
              <a-input-number :min="0" class="m-width-full"
                v-model="item.dtl.pipelinePlafon"
                @keydown="onlyNumber"
                @change="countTotalTemp(true, item.direktorat, index)"
              :formatter="(value) => (`${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')).toString()"
                :parser="value => ('  '+value.replace(/\$\s?|(,*)/g, '')).toString()"
              >
              </a-input-number>
            </a-form-model-item>
          </template>
          <template slot="directorateCost" slot-scope="text, item, index">
            <div v-if="modal_create.form.typeAnnual && modal_create.form.typeAnnual=='X_ABAIKAN_X' &&
                  item.direktorat.toLowerCase()=='total'">
              <div class="m-text-align-center">
                  <small> {{ item.direktorat.toLowerCase()=="total" ? "TOTAL DIRECTORATE COST :" : "" }} </small>
              </div>
            </div>
            <a-form-model-item v-else :prop="'directorateCost_'+index+'_'+item.direktorat" type="number" required>
              <a-input-number :min="0" class="m-width-full"
                v-model="item.dtl.directorateCost"
                @keydown="onlyNumber"
                @change="countTotalTemp"
                :formatter="(value) => (`${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')).toString()"
                :parser="value => ('  '+value.replace(/\$\s?|(,*)/g, '')).toString()"
                >
              </a-input-number>
            </a-form-model-item>
          </template>
          <template slot="valuePlafon" slot-scope="item">
            <a-form-model-item :prop="item.dtl.valuePlafon?item.dtl.valuePlafon.toString():null"
              v-if="modal_create.form.typeAnnual && modal_create.form.typeAnnual.toLowerCase()!='X_ABAIKAN_X' &&
                item.direktorat.toLowerCase()!='total'">
              <a-input-number :min="0" class="m-width-full"
                v-model="item.dtl.valuePlafon"
                @keydown="onlyNumber"
                @change="countTotalTemp"
                :formatter="(value) => (`${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')).toString()"
                :parser="value => ('  '+value.replace(/\$\s?|(,*)/g, '')).toString()"
                >
              </a-input-number>
            </a-form-model-item>
          </template>
        </a-table>
        <a-form-model-item label="Upload File Support">
          <a-upload :showUploadList="true" :fileList="modal_create.fileList"
            v-model="modal_create.form.document_support" accept=".jpg, .png, .pdf" :remove="handleRemove" :beforeUpload="beforeUpload">
            <a-button> <a-icon type="upload" />Select File </a-button>
          </a-upload>
        </a-form-model-item>
      </a-form-model>
      <template slot="footer">
        <a-button key="back" type="danger" @click="handleCancelCreate">
          Cancel
        </a-button>
        <a-button key="submit" type="primary" 
        :loading="loading.saveCreate" 
        @click="handleOkCreate"
        :disabled="totalTemp>modal_create.form.actual_value_cashflow || loading.getrealization"
        >
          Submit
        </a-button>
      </template>
    </a-spin>
    </a-modal>
  </a-card>
</template>
<script>
import { mapGetters, mapActions } from "vuex"
import GlobalMethod from "@/mixins/GlobalMethod.js"
import CurrencyFormat from "@/mixins/CurrencyFormat";
import Details from "./details"
import moment from "moment";

export default {
  name: "AnnualPlafon",
  components: {
    Details,
  },
  mixins: [GlobalMethod, CurrencyFormat],
  data() {
    let checkVal = (rule, value, callback) => {
      let item = rule.field.split('_')
      if(item[0]=='pipelinePlafon' && this.modal_create.tableForm[item[1]].dtl.pipelinePlafon==null ||
      item[0]=='directorateCost' && this.modal_create.tableForm[item[1]].dtl.directorateCost==null
      ){
        callback(new Error("Value cannot be empty!"));
        return
      }
      callback();
    };
    return {
      checkVal,
      loading:{
        page: false,
        show_load: false,
        saveCreate: false,
        getrealization: false
      },
      search: null,
      year: null,
      version:null,
      versionOri:null,
      header: null,
      dtl: null,
      selected: {
        year: null,
        type: null,
        version: null
      },
      columns:[
        {
          title: 'hdr',
          scopedSlots: { customRender: 'hdr' },
        },
      ],
      data_header: {
        cashflow_value: 0,
        est_contract_value: 0,
        total_allocated: 0,
        total_plafon: 0, 
        total_realization: 0,
        realization_value: 0
      },
      data_detail:{
        loading: false,
        data: []
      },
      activeKey: {
        header: 1
      },
      modal_create:{
        visible: false,
        optionyear: [],
        form:{
          year: null,
          typeAnnual: null,
          est_pipeline_plafon: 0,
          est_directorate_cost: 0,
          actual_value_cashflow: 0,
          total_est_contract_value: null,
          estimatePipelinePlafon: 0,
          estimateDirectorateCost: 0,
          estimatePlafon: 0,
          marketing: 0,
          realized_marketing: 0,
          quality: 0,
          realized_quality: 0,
          site_jakarta: 0,
          realized_site_jakarta: 0,
          corporate: 0,
          realized_corporate: 0,
          finance: 0,
          realized_finance: 0,
          operation: 0,
          realized_operation: 0,
          technology: 0,
          realized_technology: 0,
          ibd: 0,
          realized_ibd: 0,
          document_support: [],
          pipelinePlafonProps: 0,
          pipelinePlafon_0_Finance: 0,
          pipelinePlafon_1_Corporate: 0,
          pipelinePlafon_2_Marketing: 0,
          pipelinePlafon_3_Operation: 0,
          pipelinePlafon_4_Technology: 0,
          pipelinePlafon_5_Ibd: 0,
          directorateCost_0_Finance: 0,
          directorateCost_1_Corporate: 0,
          directorateCost_2_Marketing: 0,
          directorateCost_3_Operation: 0,
          directorateCost_4_Technology: 0,
          directorateCost_5_Ibd: 0,
        },
        rules:{
          year: [{ required: true }],
          typeAnnual: [{ required: true }],
          ecv: [{ required: false }],
          est_pipeline_plafon: [{ required: true, type: 'text', validator: checkVal },],
          est_directorate_cost: [{ required: true, type: 'text', validator: checkVal },],
          estimatePipelinePlafon: [{ required: true, type: 'text', validator: checkVal },],
          estimateDirectorateCost: [{ required: true, type: 'text', validator: checkVal },],
          actual_value_cashflow: [{ required: true }],
          total_est_contract_value: [{ required: false }],
          marketing: [{ required: false }],
          quality: [{ required: false }],
          site_jakarta: [{ required: false }],
          corporate: [{ required: false }],
          finance: [{ required: false }],
          operation: [{ required: false }],
          technology: [{ required: false }],
          ibd: [{ required: false }],
          pipelinePlafon_0_Finance: [{ required: true, type: 'text', validator: checkVal },],
          pipelinePlafon_0_Corporate: [{ required: true, type: 'text', validator: checkVal },],
          pipelinePlafon_1_Marketing: [{ required: true, type: 'text', validator: checkVal },],
          pipelinePlafon_2_Operation: [{ required: true, type: 'text', validator: checkVal },],
          pipelinePlafon_3_Technology: [{ required: true, type: 'text', validator: checkVal },],
          pipelinePlafon_4_Ibd: [{ required: true, type: 'text', validator: checkVal },],
        },
        fileList: [],
        tableForm:[
          { direktorat: 'Finance',
            dtl : {
              pipelinePlafon: "0",
              directorateCost: "0",
              valuePlafon: "0",
              totalRow: "0",
              isoverlimit: false,
            }
          },
          { direktorat: 'Corporate',
            dtl : {
              pipelinePlafon: "0",
              directorateCost: "0",
              valuePlafon: "0",
              totalRow: "0",
              isoverlimit: false,
            }
          },
          { direktorat: 'Marketing',
            dtl : {
              pipelinePlafon: "0",
              directorateCost: "0",
              valuePlafon: "0",
              totalRow: "0",
              isoverlimit: false,
            }
          },
          { direktorat: 'Operation',
            dtl : {
              pipelinePlafon: "0",
              directorateCost: "0",
              valuePlafon: "0",
              totalRow: "0",
              isoverlimit: false,
            }
          },
          { direktorat: 'Technology',
            dtl : {
              pipelinePlafon: "0",
              directorateCost: "0",
              valuePlafon: "0",
              totalRow: "0",
              isoverlimit: false,
            }
          },
          { direktorat: 'International Business Development',
            dtl : {
              pipelinePlafon: "0",
              directorateCost: "0",
              valuePlafon: "0",
              totalRow: "0",
              isoverlimit: false,
            }
          },
        ],
        isoverlimitPipeline: false,
        isoverlimitDirectorateCost: false,
        isoverlimitPlafon: false,
        totalPipeline: 0,
        totalDirectorateCost: 0,
        totalPlafon: 0,
      },
      totalTemp: 0,
      editable: false,
      typeList: [],
      allowtoFillFetchData: false
    }
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getDefaultDateFormat",
      "getAuth",
      "getDateTimeFormat",
    ]),
    isVPF(){
      return this.$route.path.includes('/vpf') ? true :false
    },
    isOPC(){
      let temp = false
      this.getAuth.divisi.forEach(element => {
        if(element=='Operation Planning and Control')
        temp = true
      });
      return temp
    },
    isKeu(){
      let temp = false
      this.getAuth.divisi.forEach(element => {
        if(element.toLowerCase()=='keuangan')
        temp = true
      });
      return temp
    },
    columnForm(){
      let col = [
        {
          title: "Directorate",
          key: "directorate",
          width: 250,
          align: "left",
          scopedSlots: { customRender: "directorate" },
        }
      ]
      this.modal_create.form.typeAnnual=='X_ABAIKAN_X' ? 
        col.splice(1,0,
          {
            slots: { title: 'pipelineHeaderTitle' },
            key: "pipelinePlafon",
            align: "center",
            scopedSlots: { customRender: "pipelinePlafon" },
          },
          {
            slots: { title: 'directorateCostHeaderTitle' },
            key: "directorateCost",
            align: "center",
            scopedSlots: { customRender: "directorateCost" },
          },
        )
        : col.splice(1,0,
          {
            slots: { title: 'plafonHeaderTitle' },
            key: "valuePlafon",
            align: "center",
            scopedSlots: { customRender: "valuePlafon" },
          }
        )
      return col
    },
    yearComputed(){
      return this.selected.type ? this.year.filter((item)=>item.type==this.selected.type) : []
    },
  },
  methods:{
    moment,
    async fetch(){

      this.rerenderfocusedRow(null);

      this.loading.page = true

      let params = {
        jenis: "annual"
      }
      if(this.selected.year){
        params["year"] = this.selected.year
        params["version"] = this.selected.version
        params["type"] = this.selected.type
      }

      //reset tampilan detil
      this.data_detail.loading = false
      this.data_detail.data = []

      await this.asyncAxiosGet("plafon",
        this.getAuth, params
      )
      .then((res) => {
        this.year = res.filter_year
        this.typeList = res.filter_type
        this.versionOri = res.filter_version
        if(this.selected.type)
          this.version = this.versionOri.filter((item) => item.year==res.header[0].year && item.type==res.header[0].type)

        if(res.header.length>0 && this.allowtoFillFetchData){
          this.data_header = res.header[0]
          this.dtl = res.dtl

          this.selected.year = res.header[0].year
          this.selected.type = res.header[0].type
          this.selected.version = res.header[0].version
        }else{
          this.data_header = []
          this.dtl = []
          // this.displayMessageValue("basic-info", res.message);
        }

        this.loading.page = false
      })
    },
    rerenderfocusedRow(e){
      let a = document.getElementsByClassName("isfocused");
      if(a.length>0){
        for (let index = 0; index < a.length; index++) {
          a[index].classList.remove("isfocused");
        }
      }
      if(e!=null)
      e.target.parentElement.parentElement.classList.add("isfocused");
    },
    async showdtlData(e,id){
      this.rerenderfocusedRow(e)
      if(this.getScreen)
        this.activeKey.header = null
      
      if(this.isOPC){
        let temp = this.dtl.filter((item)=>item.id_dtl==id)
        if(temp.length>0 && temp[0].directorat!='Operation'){
          this.displayMessageValue("basic-warning", "Access Denied!");
          return;
        }
      }

      this.data_detail.loading = true
      await this.asyncAxiosGet("plafon/detil",
        this.getAuth, {
          jenis: 'annual',
          id_dtl: id
        }
      )
      .then((res) => {
        let budget = []
        res.budget.forEach(element => {
          budget.push({ 
            key: element.kode_jenis,
            title: "("+element.kode_jenis+") "+ element.nm_anggaran,
            isLeaf: element.nilai==0,
            value: element.nilai,
            id_dtl: element.id_dtl,
            scopedSlots: { title: 'title'}
          })
        });
        this.data_detail.data= {
          allocation: res.allocation[0],
          budget: budget
        }
        this.data_detail.loading = false
      })
    },
    changeType(val){
      this.selected.year = null
      this.selected.version = null
      this.version = []

      this.data_header = []
      this.dtl = []
      this.data_detail.data = []

      if(this.yearComputed.length>0){
        let tempyear = this.yearComputed.filter((item)=> item.type==val && item.year==moment().format("YYYY"))
        if(tempyear.length>0){
          this.selected.year = tempyear[0].year
          this.changeYear(this.selected.year)
        }
      }
    },
    changeYear(val){
      this.modal_create.form.actual_value_cashflow = 0
      this.data_header = []
      this.dtl = []
      this.data_detail.data = []

      this.version = this.versionOri.filter((item) => item.year==val && item.type==this.selected.type)
      let tempver = this.version.filter((item) =>item.active_sts=='1')
      if(tempver.length>0){
        this.selected.version =tempver[0].version
        this.allowtoFillFetchData = true
        this.fetch()
      }else{
        this.selected.version =null
      }
    },
    changeVersion(){
      this.allowtoFillFetchData = true
      this.fetch()
    },
    updateChildBudget(val){
      this.data_detail.data.budget = val
    },
    nullToNol(val){
      return val?val:0
    },
    async getRealizedPlafonOnCreate(){
      this.modal_create.isoverlimitPipeline = false
      this.modal_create.isoverlimitDirectorateCost = false
      this.modal_create.isoverlimitPlafon = false

      this.loading.getrealization = true
      await this.asyncAxiosGet("plafon/realization_per_year",
        this.getAuth, { year: this.modal_create.form.year, type:this.modal_create.form.typeAnnual})
        .then((res2) => {
          // this.modal_create.form.actual_value_cashflow = this.nullToNol(res2.last_plafon[0].est_cast_flow_value)
          this.modal_create.form.estimatePipelinePlafon = this.nullToNol(res2.last_plafon[0].est_pipeline)
          this.modal_create.form.estimateDirectorateCost = this.nullToNol(res2.last_plafon[0].est_biaya_direktorat)
          this.modal_create.form.actual_value_cashflow = Number(this.modal_create.form.estimatePipelinePlafon) +
          Number(this.modal_create.form.estimateDirectorateCost)+Number(this.modal_create.form.estimatePlafon)

          if(this.modal_create.form.typeAnnual && this.modal_create.form.typeAnnual!='X_ABAIKAN_X')
            this.modal_create.tableForm[0].dtl.valuePlafon = 0

          this.modal_create.tableForm[0].dtl.directorateCost = this.nullToNol(res2.last_plafon[0].finance_biaya_direktorat)
          this.modal_create.tableForm[0].dtl.pipelinePlafon = this.nullToNol(res2.last_plafon[0].finance_pipeline_plafon)
          this.modal_create.tableForm[0].dtl.totalRow = this.nullToNol(res2.last_plafon[0].finance_plafon)
          if(this.modal_create.form.typeAnnual && this.modal_create.form.typeAnnual!='X_ABAIKAN_X'){
            this.modal_create.tableForm[0].dtl.valuePlafon = this.nullToNol(res2.last_plafon[0].finance_plafon)
          }else{
            this.modal_create.tableForm[0].dtl.valuePlafon = 0 
          }

          this.modal_create.tableForm[1].dtl.directorateCost = this.nullToNol(res2.last_plafon[0].corporat_biaya_direktorat)
          this.modal_create.tableForm[1].dtl.pipelinePlafon = this.nullToNol(res2.last_plafon[0].corporat_pipeline_plafon)
          this.modal_create.tableForm[1].dtl.totalRow = this.nullToNol(res2.last_plafon[0].corporate_plafon)
          if(this.modal_create.form.typeAnnual && this.modal_create.form.typeAnnual!='X_ABAIKAN_X'){
            this.modal_create.tableForm[1].dtl.valuePlafon = this.nullToNol(res2.last_plafon[0].corporate_plafon)
          }else{
            this.modal_create.tableForm[1].dtl.valuePlafon = 0 
          }

          this.modal_create.tableForm[2].dtl.directorateCost = this.nullToNol(res2.last_plafon[0].marketing_biaya_direktorat)
          this.modal_create.tableForm[2].dtl.pipelinePlafon = this.nullToNol(res2.last_plafon[0].marketing_pipeline_plafon)
          this.modal_create.tableForm[2].dtl.totalRow = this.nullToNol(res2.last_plafon[0].marketing_plafon)
          if(this.modal_create.form.typeAnnual && this.modal_create.form.typeAnnual!='X_ABAIKAN_X'){
            this.modal_create.tableForm[2].dtl.valuePlafon = this.nullToNol(res2.last_plafon[0].marketing_plafon)
          }else{
            this.modal_create.tableForm[2].dtl.valuePlafon = 0 
          }

          this.modal_create.tableForm[3].dtl.directorateCost = this.nullToNol(res2.last_plafon[0].operation_biaya_direktorat)
          this.modal_create.tableForm[3].dtl.pipelinePlafon = this.nullToNol(res2.last_plafon[0].operation_pipeline_plafon)
          this.modal_create.tableForm[3].dtl.totalRow = this.nullToNol(res2.last_plafon[0].operation_plafon)
          if(this.modal_create.form.typeAnnual && this.modal_create.form.typeAnnual!='X_ABAIKAN_X'){
            this.modal_create.tableForm[3].dtl.valuePlafon = this.nullToNol(res2.last_plafon[0].operation_plafon)
          }else{
            this.modal_create.tableForm[3].dtl.valuePlafon = 0 
          }

          this.modal_create.tableForm[4].dtl.directorateCost = this.nullToNol(res2.last_plafon[0].technology_biaya_direktorat)
          this.modal_create.tableForm[4].dtl.pipelinePlafon = this.nullToNol(res2.last_plafon[0].technology_pipeline_plafon)
          this.modal_create.tableForm[4].dtl.totalRow = this.nullToNol(res2.last_plafon[0].technology_plafon) 
          if(this.modal_create.form.typeAnnual && this.modal_create.form.typeAnnual!='X_ABAIKAN_X'){
            this.modal_create.tableForm[4].dtl.valuePlafon = this.nullToNol(res2.last_plafon[0].technology_plafon)
          }else{
            this.modal_create.tableForm[4].dtl.valuePlafon = 0 
          }

          this.modal_create.tableForm[5].dtl.directorateCost = this.nullToNol(res2.last_plafon[0].ibd_biaya_direktorat)
          this.modal_create.tableForm[5].dtl.pipelinePlafon = this.nullToNol(res2.last_plafon[0].ibd_pipeline_plafon)
          this.modal_create.tableForm[5].dtl.totalRow = this.nullToNol(res2.last_plafon[0].ibd_plafon) 
          if(this.modal_create.form.typeAnnual && this.modal_create.form.typeAnnual!='X_ABAIKAN_X'){
            this.modal_create.tableForm[5].dtl.valuePlafon = this.nullToNol(res2.last_plafon[0].ibd_plafon)
          }else{
            this.modal_create.tableForm[5].dtl.valuePlafon = 0 
          }

          if(res2.realisasi[0] && this.modal_create.form.typeAnnual!=null){
            this.modal_create.form.realized_finance = this.nullToNol(res2.realisasi[0].realisasi_finance)
            this.modal_create.form.realized_corporate = this.nullToNol(res2.realisasi[0].realisasi_corporate)
            this.modal_create.form.realized_marketing = this.nullToNol(res2.realisasi[0].realisasi_marketing)
            this.modal_create.form.realized_operation = this.nullToNol(res2.realisasi[0].realisasi_operation)
            this.modal_create.form.realized_technology = this.nullToNol(res2.realisasi[0].realisasi_technology)
            this.modal_create.form.realized_ibd = this.nullToNol(res2.realisasi[0].realisasi_ibd)
          }else{
            this.modal_create.form.realized_finance = 0
            this.modal_create.form.realized_corporate = 0
            this.modal_create.form.realized_marketing = 0
            this.modal_create.form.realized_operation = 0
            this.modal_create.form.realized_technology = 0
            this.modal_create.form.realized_ibd = 0
          }

          this.countTotalTemp()  

          this.loading.getrealization = false
        })
    },
    async showCreateDialog(){
      this.modal_create.mode='create'
      for (let index = 0; index < 6; index++) {
        this.modal_create.tableForm[index].dtl.valuePlafon = 0
      }

      this.loading.show_load = true
      await this.asyncAxiosGet("plafon/pipeline_per_year",
        this.getAuth, {}
      )
      .then(async (res) => {
        this.modal_create.optionyear = res.est_contract_value

        //default awal Operational
        this.modal_create.form.typeAnnual = null
        this.modal_create.form.year = this.modal_create.optionyear[this.modal_create.optionyear.length-1].year
        // this.modal_create.form.total_est_contract_value = this.modal_create.optionyear[this.modal_create.optionyear.length-1].est_contract_value
        this.modal_create.form.estimatePipelinePlafon = this.modal_create.optionyear[this.modal_create.optionyear.length-1].total_pipeline_plafon
        this.modal_create.form.estimateDirectorateCost = this.modal_create.optionyear[this.modal_create.optionyear.length-1].total_biaya_direktorat

        this.modal_create.form.realized_finance = 0
        this.modal_create.form.realized_corporate = 0
        this.modal_create.form.realized_marketing = 0
        this.modal_create.form.realized_operation = 0
        this.modal_create.form.realized_technology = 0
        this.modal_create.form.realized_ibd = 0

        this.modal_create.tableForm[0].dtl.pipelinePlafon = this.modal_create.optionyear[this.modal_create.optionyear.length-1].plafon_pipeline_finance ? 
                                                            this.modal_create.optionyear[this.modal_create.optionyear.length-1].plafon_pipeline_finance : 0
        this.modal_create.tableForm[1].dtl.pipelinePlafon = this.modal_create.optionyear[this.modal_create.optionyear.length-1].plafon_pipeline_corporate ? 
                                                            this.modal_create.optionyear[this.modal_create.optionyear.length-1].plafon_pipeline_corporate : 0
        this.modal_create.tableForm[2].dtl.pipelinePlafon = this.modal_create.optionyear[this.modal_create.optionyear.length-1].plafon_pipeline_marketing ? 
                                                            this.modal_create.optionyear[this.modal_create.optionyear.length-1].plafon_pipeline_marketing : 0
        this.modal_create.tableForm[3].dtl.pipelinePlafon = this.modal_create.optionyear[this.modal_create.optionyear.length-1].plafon_pipeline_operation ? 
                                                            this.modal_create.optionyear[this.modal_create.optionyear.length-1].plafon_pipeline_operation : 0
        this.modal_create.tableForm[4].dtl.pipelinePlafon = this.modal_create.optionyear[this.modal_create.optionyear.length-1].plafon_pipeline_technology ? 
                                                            this.modal_create.optionyear[this.modal_create.optionyear.length-1].plafon_pipeline_technology : 0
        this.modal_create.tableForm[5].dtl.pipelinePlafon = this.modal_create.optionyear[this.modal_create.optionyear.length-1].plafon_pipeline_ibd ? 
                                                            this.modal_create.optionyear[this.modal_create.optionyear.length-1].plafon_pipeline_ibd : 0
        this.modal_create.tableForm[0].dtl.directorateCost = 0
        this.modal_create.tableForm[1].dtl.directorateCost = 0
        this.modal_create.tableForm[2].dtl.directorateCost = 0
        this.modal_create.tableForm[3].dtl.directorateCost = 0
        this.modal_create.tableForm[4].dtl.directorateCost = 0
        this.modal_create.tableForm[5].dtl.directorateCost = 0

        this.resetModalCreate()
        this.countTotalTemp()      

        this.loading.show_load = false
        this.modal_create.visible = true

        this.loading.getrealization = true
        // await this.getRealizedPlafonOnCreate()
        // .then(() => {
        //   this.loading.show_load = false
          this.loading.getrealization = false
        //   this.modal_create.visible = true
        // })
      })
    },
    async showEditDialog(e){
      e.stopPropagation();
      this.modal_create.mode='edit'
      this.modal_create.form.year = this.selected.year
      this.modal_create.optionyear = this.year 
      this.modal_create.form.total_est_contract_value = this.data_header.est_contract_value
      // this.modal_create.form.actual_value_cashflow = this.data_header.cashflow_value 
      this.modal_create.form.actual_value_cashflow = Number(this.data_header.estimatepipelineplafon) +
        Number(this.data_header.estimatedirectoratecost)
      this.modal_create.form.typeAnnual = this.data_header.type
      this.modal_create.form.estimatePipelinePlafon = this.data_header.estimatepipelineplafon
      this.modal_create.form.estimateDirectorateCost = this.data_header.estimatedirectoratecost
      let a=0,b=0,c=0
      this.dtl.forEach(element => {
        if(element.directorat.toLowerCase()=='marketing'){
          this.modal_create.form.marketing = Number(element.plafon_value)

          this.modal_create.tableForm[2].dtl.directorateCost = this.nullToNol(element.biaya_direktorat_plafon)
          this.modal_create.tableForm[2].dtl.pipelinePlafon = this.nullToNol(element.pipeline_plafon)
          this.modal_create.tableForm[2].dtl.valuePlafon = this.nullToNol(element.plafon_value)
          this.modal_create.tableForm[2].dtl.totalRow = this.nullToNol(element.plafon_value)

          this.modal_create.form.realized_marketing = this.nullToNol(element.realization_value)
          a+=this.nullToNol(element.biaya_direktorat_plafon)
          b+=this.nullToNol(element.pipeline_plafon)
          c+=this.nullToNol(element.plafon_value)
        }else if(element.directorat.toLowerCase()=='corporate'){
          this.modal_create.form.corporate = Number(element.plafon_value)

          this.modal_create.tableForm[1].dtl.directorateCost = this.nullToNol(element.biaya_direktorat_plafon)
          this.modal_create.tableForm[1].dtl.pipelinePlafon = this.nullToNol(element.pipeline_plafon)
          this.modal_create.tableForm[1].dtl.valuePlafon = this.nullToNol(element.plafon_value)
          this.modal_create.tableForm[1].dtl.totalRow = this.nullToNol(element.plafon_value)

          this.modal_create.form.realized_corporate = this.nullToNol(element.realization_value)
          a+=this.nullToNol(element.biaya_direktorat_plafon)
          b+=this.nullToNol(element.pipeline_plafon)
          c+=this.nullToNol(element.plafon_value)
        }else if(element.directorat.toLowerCase()=='finance'){
          this.modal_create.form.finance = Number(element.plafon_value)

          this.modal_create.tableForm[0].dtl.directorateCost = this.nullToNol(element.biaya_direktorat_plafon)
          this.modal_create.tableForm[0].dtl.pipelinePlafon = this.nullToNol(element.pipeline_plafon)
          this.modal_create.tableForm[0].dtl.valuePlafon = this.nullToNol(element.plafon_value)
          this.modal_create.tableForm[0].dtl.totalRow = this.nullToNol(element.plafon_value)

          this.modal_create.form.realized_finance = this.nullToNol(element.realization_value)
          a+=this.nullToNol(element.biaya_direktorat_plafon)
          b+=this.nullToNol(element.pipeline_plafon)
          c+=this.nullToNol(element.plafon_value)
        }else if(element.directorat.toLowerCase()=='operation'){
          this.modal_create.form.operation = Number(element.plafon_value)

          this.modal_create.tableForm[3].dtl.directorateCost = this.nullToNol(element.biaya_direktorat_plafon)
          this.modal_create.tableForm[3].dtl.pipelinePlafon = this.nullToNol(element.pipeline_plafon)
          this.modal_create.tableForm[3].dtl.valuePlafon = this.nullToNol(element.plafon_value)
          this.modal_create.tableForm[3].dtl.totalRow = this.nullToNol(element.plafon_value)

          this.modal_create.form.realized_operation = this.nullToNol(element.realization_value)
          a+=this.nullToNol(element.biaya_direktorat_plafon)
          b+=this.nullToNol(element.pipeline_plafon)
          c+=this.nullToNol(element.plafon_value)
        }else if(element.directorat.toLowerCase()=='technology'){
          this.modal_create.form.technology = Number(element.plafon_value)

          this.modal_create.tableForm[4].dtl.directorateCost = this.nullToNol(element.biaya_direktorat_plafon)
          this.modal_create.tableForm[4].dtl.pipelinePlafon = this.nullToNol(element.pipeline_plafon)
          this.modal_create.tableForm[4].dtl.valuePlafon = this.nullToNol(element.plafon_value)
          this.modal_create.tableForm[4].dtl.totalRow = this.nullToNol(element.plafon_value)

          this.modal_create.form.realized_technology = this.nullToNol(element.realization_value)
          a+=this.nullToNol(element.biaya_direktorat_plafon)
          b+=this.nullToNol(element.pipeline_plafon)
          c+=this.nullToNol(element.plafon_value)
        }else if(element.directorat.toLowerCase()=='international business development'){
          this.modal_create.form.ibd = Number(element.plafon_value)

          this.modal_create.tableForm[5].dtl.directorateCost = this.nullToNol(element.biaya_direktorat_plafon)
          this.modal_create.tableForm[5].dtl.pipelinePlafon = this.nullToNol(element.pipeline_plafon)
          this.modal_create.tableForm[5].dtl.valuePlafon = this.nullToNol(element.plafon_value)
          this.modal_create.tableForm[5].dtl.totalRow = this.nullToNol(element.plafon_value)

          this.modal_create.form.realized_ibd = this.nullToNol(element.realization_value)
          a+=this.nullToNol(element.biaya_direktorat_plafon)
          b+=this.nullToNol(element.pipeline_plafon)
          c+=this.nullToNol(element.plafon_value)
        }
      });

      this.countTotalTemp()

      this.modal_create.visible = true
    },
    resetModalCreate(){
      this.totalTemp = 0
      this.modal_create.fileList = []
    },
    async changeYearCreate(val){
      let a = this.modal_create.optionyear.filter((obj) => obj.year==val)
      this.modal_create.form.year = a[0].year
      this.modal_create.form.total_est_contract_value = a[0].est_contract_value
      this.modal_create.form.estimatePipelinePlafon = a[0].total_pipeline_plafon
      this.modal_create.form.estimateDirectorateCost = a[0].total_biaya_direktorat
      if(this.modal_create.form.typeAnnual==null){
        this.displayMessageValue("basic-warning", "Cannot get Realized data cause type annual is empty!");
      }else{
        this.getRealizedPlafonOnCreate()
      }
    },
    changeTypeAnnual(){
      this.getRealizedPlafonOnCreate()
    },
    handleOkCreate(){
      this.$refs.entriForm.validate((valid) => {
        if (!valid) {
          this.displayMessage("form-warning");
          return;
        }

        let that = this
        this.$confirm({
        title: "Are you sure to save this data?",
        content: '',
        okText: 'Yes',
        cancelText: 'No',
        onOk() {
          let isRowovervalue =  false
          // if(that.modal_create.form.typeAnnual=='X_ABAIKAN_X'){
          //   isRowovervalue = that.modal_create.isoverlimitPipeline || that.modal_create.isoverlimitDirectorateCost || that.modal_create.isoverlimitPlafon
          // }else{
          //   isRowovervalue = that.modal_create.isoverlimitPlafon
          // }

          for (let index = 0; index < 6; index++) {
            if(that.modal_create.tableForm[index].dtl.isoverlimit==true)
              isRowovervalue = true
          }

          if(isRowovervalue){
            that.displayMessageValue("error-other", "Value Entries is not valid, plase check it again!");
          }else{
            let data = new FormData();
            data.append("year", that.modal_create.form.year);
            data.append("actual_value_cashflow", that.nullToNol(that.modal_create.form.actual_value_cashflow));
            data.append("total_est_contract_value", that.nullToNol(that.modal_create.form.total_est_contract_value));
            data.append("type", that.nullToNol(that.modal_create.form.typeAnnual));

            if(that.modal_create.form.typeAnnual && that.modal_create.form.typeAnnual=='X_ABAIKAN_X'){
              // data.append("TotalDirectorateCost", that.nullToNol(that.modal_create.tableForm[0-].dtl.totalDirectorateCost));
              // data.append("TotalPipelinePlafon", that.nullToNol(that.modal_create.tableForm[0-].dtl.totalPipelinePlafon));
              data.append("EstimateDirectorateCost", that.nullToNol(that.modal_create.form.estimateDirectorateCost));
              data.append("EstimatePipelinePlafon", that.nullToNol(that.modal_create.form.estimatePipelinePlafon));
            }else{
              data.append("TotalDirectorateCost", 0);
              data.append("TotalPipelinePlafon", 0);
              data.append("EstimateDirectorateCost", 0);
              data.append("EstimatePipelinePlafon", 0);
            }
            // data.append("TotalPlafonTotal", that.nullToNol(that.modal_create.tableForm[0-].dtl.totalRow));

            data.append("PipelinePlafonFinance", that.nullToNol(that.modal_create.tableForm[0].dtl.pipelinePlafon));
            data.append("DirectorateCostFinance", that.nullToNol(that.modal_create.tableForm[0].dtl.directorateCost));
            data.append("TotalPlafonFinance", that.nullToNol(that.modal_create.tableForm[0].dtl.totalRow));

            data.append("PipelinePlafonCorporate", that.nullToNol(that.modal_create.tableForm[1].dtl.pipelinePlafon));
            data.append("DirectorateCostCorporate", that.nullToNol(that.modal_create.tableForm[1].dtl.directorateCost));
            data.append("TotalPlafonCorporate", that.nullToNol(that.modal_create.tableForm[1].dtl.totalRow));

            data.append("PipelinePlafonMarketing", that.nullToNol(that.modal_create.tableForm[2].dtl.pipelinePlafon));
            data.append("DirectorateCostMarketing", that.nullToNol(that.modal_create.tableForm[2].dtl.directorateCost));
            data.append("TotalPlafonMarketing", that.nullToNol(that.modal_create.tableForm[2].dtl.totalRow));

            data.append("PipelinePlafonOperation", that.nullToNol(that.modal_create.tableForm[3].dtl.pipelinePlafon));
            data.append("DirectorateCostOperation", that.nullToNol(that.modal_create.tableForm[3].dtl.directorateCost));
            data.append("TotalPlafonOperation", that.nullToNol(that.modal_create.tableForm[3].dtl.totalRow));

            data.append("PipelinePlafonTechnology", that.nullToNol(that.modal_create.tableForm[4].dtl.pipelinePlafon));
            data.append("DirectorateCostTechnology", that.nullToNol(that.modal_create.tableForm[4].dtl.directorateCost));
            data.append("TotalPlafonTechnology", that.nullToNol(that.modal_create.tableForm[4].dtl.totalRow));

            data.append("PipelinePlafonIbd", that.nullToNol(that.modal_create.tableForm[5].dtl.pipelinePlafon));
            data.append("DirectorateCostIbd", that.nullToNol(that.modal_create.tableForm[5].dtl.directorateCost));
            data.append("TotalPlafonIbd", that.nullToNol(that.modal_create.tableForm[5].dtl.totalRow));
            
            if(that.modal_create.fileList.length>0)
              data.append("document_support", that.modal_create.fileList[0]);

            let url = "plafon/annual"
            if(that.modal_create.mode=='edit'){
              url = "plafon/annual_edit"
              data.append("id", that.data_header.id)
            }

            that.loading.saveCreate = true
            that.asyncAxiosPost(url, "formdata", that.getAuth, data)
            .then((response) => {
              that.displayMessageValue("success-other", response.message);
              that.loading.saveCreate = false
              that.modal_create.visible = false
              that.allowtoFillFetchData = true
              if(that.modal_create.mode=='edit'){
                that.changeVersion()
                that.fetch()
              }else{
                that.selected.version = null
                that.selected.year = null
                that.fetch()
              }
              
            }).catch(()=>{
              that.loading.saveCreate = false
            })
          }
        },
          onCancel() { },
        });
      })
    },
    handleCancelCreate(){
      this.modal_create.form.actual_value_cashflow = null
      this.modal_create.form.total_est_contract_value = null
      this.modal_create.form.marketing = null
      this.modal_create.form.quality = null
      this.modal_create.form.site_jakarta = null
      this.modal_create.form.corporate = null
      this.modal_create.form.finance = null
      this.modal_create.form.operation = null
      this.modal_create.form.technology = null
      this.modal_create.form.ibd = null
      this.modal_create.fileList = []

      this.totalTemp = 0
      this.modal_create.visible = false
    },
    gotoManifest(id){
      let page = "_otherpage";
      if(this.isVPF){
        page = 'MonthlyAnnualManifest_Vpf'
      } else if(this.$route.path.includes("/financialControl")){
         page = 'MonthlyAnnualManifestFin'
      } else if(this.$route.path.includes("/opc")){
        page = 'MonthlyAnnualManifestOPC'
      } else if(this.$route.path.includes("/keuangan/")){
        page = 'MonthlyAnnualManifestKeu'
      } else if(this.$route.path.includes("/directorate-delegation/")){
        page = 'MonthlyAnnualManifestDirDel'
      }else{
        page = 'MonthlyAnnualManifestDir'
      }
      this.$router.push({ name: page, params: { id: id, type: "1" } });
    },
    countTotalTemp(){
      //recounting
      let a=0,b=0,c=0
      if(this.modal_create.form.typeAnnual && this.modal_create.form.typeAnnual=='X_ABAIKAN_X'){
        for (let index = 0; index < 6; index++) {
          a+=Number(this.modal_create.tableForm[index].dtl.pipelinePlafon)
          b+=Number(this.modal_create.tableForm[index].dtl.directorateCost)

          this.modal_create.tableForm[index].dtl.totalRow = 
            Number(this.modal_create.tableForm[index].dtl.pipelinePlafon) + Number(this.modal_create.tableForm[index].dtl.directorateCost)
          this.modal_create.tableForm[index].dtl.isoverlimit = Number(this.modal_create.tableForm[index].dtl.totalRow) <
            Number(this.modal_create.form['realized_'+this.modal_create.tableForm[index].direktorat.toLowerCase()])
        }
      }else{
        // let ctotal = 0
        for (let index = 0; index < 6; index++) {
          c+=Number(this.modal_create.tableForm[index].dtl.valuePlafon)

          this.modal_create.tableForm[index].dtl.totalRow = this.modal_create.tableForm[index].dtl.valuePlafon
          // ctotal += Number(this.modal_create.tableForm[index].dtl.totalRow)

          this.modal_create.tableForm[index].dtl.isoverlimit = Number(this.modal_create.tableForm[index].dtl.totalRow) <
            Number(this.modal_create.form['realized_'+this.modal_create.tableForm[index].direktorat.toLowerCase()])
        }
      }

      this.modal_create.totalPipeline = a
      this.modal_create.totalDirectorateCost = b
      this.modal_create.totalPlafon = c

      this.modal_create.isoverlimitPipeline = a!=Number(this.modal_create.form.estimatePipelinePlafon)
      this.modal_create.isoverlimitDirectorateCost = b!=Number(this.modal_create.form.estimateDirectorateCost)
      // if(this.modal_create.form.typeAnnual=='X_ABAIKAN_X'){
      //   this.modal_create.isoverlimitPlafon = Number(this.modal_create.form.total_est_contract_value)<
      //     Number(this.modal_create.form.actual_value_cashflow)
      // }else{
      //   this.modal_create.isoverlimitPlafon = c>Number(this.modal_create.form.total_est_contract_value)
      // }
    },
    getLblSts(val){
      if(val=='active'){
        val = 'Active'
      }
      return val
    },
    handleRemove() {
      this.modal_create.fileList = [];
    },
    beforeUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 5) {
        this.displayMessage("large-file-5mb");
      } else {
          this.modal_create.fileList = [];
          this.modal_create.fileList.push(file);
        return false;
      }
    },
    validateECV(){
      let temtotal = (Number(this.modal_create.form.estimatePipelinePlafon)+Number(this.modal_create.form.estimateDirectorateCost))
      this.modal_create.form.actual_value_cashflow = temtotal
      this.countTotalTemp()
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
  },
  created() {
    this.allowtoFillFetchData = false
    this.fetch()
  },
  mounted(){
    Event.$on("annualPlafonUpdateData", this.updateChildBudget);
  },
  beforeDestroy() {
    Event.$off("annualPlafonUpdateData", this.updateChildBudget);
  }
}
</script>
<style lang="less">
.c_annualPlafon {
  .ant-card-head-title{
    margin-right: 0px!important;
  }
  .cmain-title{
    max-width: 50%;
    text-wrap: auto;
    word-break: normal;
  }
  .cbtn-create {
    i {color: #fff;}
    path{color: #fff;}
    span {color: #fff;}
  }
  .hdr_plfn{
    .ant-table-title{
      padding-bottom: 0px;
    }
  }
  .option_plfn{
    td{
    padding: 0px;
    }
  }
  .hdr_plfn_selection{
    padding: 16px;
    cursor: pointer;
  }
  .hdr_plfn_selection.isfocused  {
    background-color: fade(@color-secondary, 5%);
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.25), 0 2px 8px rgba(0, 0, 0, 0.25), inset 0px 0px 0px 1px rgba(255, 255, 255, 0.1);
    border-left-style: solid;
    border-left-color: @color-secondary;
  }
  .row-ecv{
    .ant-input-number{
      justify-content: flex-end;
    }
    .ant-input-number-input{
      text-align: right;
      display: block;
    }
  }
  .row_h{
    margin-right: 11px;
  }

  .ngabango{
    background-color: fade(@color-primary, 35%);
  }
}

.cAnnualfromcreate{
  .ant-input-number-input{
    text-align: right;
    padding-right: 25px;
  }
}

.plafonformtables{
  // .ant-table-row {
    .ant-table-thead {
     background: #c1c1c1;
     font-weight: bolder;
    }
    tr:first-child {
      td:hover {
        background: #00ca8e;
      }
    }
    td:nth-child(4){
      background: #c1c1c1;
    }

    .ant-table-thead > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected):not(.cSUMMARY) > td, 
    .ant-table-tbody > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected):not(.cSUMMARY) > td, 
    .ant-table-thead > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected):not(.cSUMMARY) > td, 
    .ant-table-tbody > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected):not(.cSUMMARY) > td {
      background: none;
    }

    .ant-table-thead > tr.cSUMMARY.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td, 
    .ant-table-tbody > tr.cSUMMARY.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td, 
    .ant-table-thead > tr.cSUMMARY:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td, 
    .ant-table-tbody > tr.cSUMMARY:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td {
     background: #c1c1c1;
    }
  // }
}

.overvalueRow{
  background-color: fade(@color-primary, 35%);
}
</style>